module.exports = __webpack_public_path__ + "static/TiemposText-Medium-f71d5023d1ea6cadb6737c888c9bbca4.woff";